import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'mail-icon',
  templateUrl: './mail-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class MailIconComponent {}
